$(document).ready(function () {
  $(".selector-wrapper select").change(function () {
    var option1 = $('.single-option-selector[data-index="option1"]').val();
    var option2 = $('.single-option-selector[data-index="option2"]').val();
    if (option2 != undefined) {
      var finalOption = option1 + " / " + option2;
    } else {
      var finalOption = option1;
    }
    var valofText = $('[name="id"] option').filter(function () {return this.text == finalOption;}).val();

    var variantMetalName = $(".swatch.metal .swatch-element input:checked + label").attr("data-colorname");
    $(".header .metalName").text(variantMetalName);
    $('[name="id"]').val(valofText).change();
  });

  $('[name="id"]').on("change", function () {
    console.log("variantChange");
    var variant = $(this).val();
    var variant_sku = $(this).children("option:selected").data("sku");
    var isVariantAvailable = $(this).children("option:selected").data("available");
    var variant_price_with_currency = $(this).children("option:selected").data("price");
    var variant_compare_price_with_currency = $(this).children("option:selected").data("compare-price");
    var variant_price_without_currency = parseInt($(this).children("option:selected").data("price-without-currency"));
    var variant_compare_price_without_currency = parseInt($(this).children("option:selected").data("compare-price-without-currency"));
    console.log(variant_compare_price_without_currency,variant_price_without_currency);
    $(".price__regular [data-regular-price]").text(variant_price_with_currency);
    $(".price__sale [data-sale-price]").text(variant_price_with_currency);
    $(".price__sale [data-regular-price]").text(variant_compare_price_with_currency);
    if (variant_compare_price_without_currency > variant_price_without_currency && variant_price_without_currency != NaN) {
      $(".product__price .price").addClass("price--on-sale");
    }
    if (variant_compare_price_without_currency < variant_price_without_currency && variant_price_without_currency != NaN) {
      $(".product__price .price").removeClass("price--on-sale");
    }
    $(".product-sku span").text(variant_sku);
    function variantAvailable() {
      $(".estimated_date,.shopify-payment-button__button,.stock__message,.delivery-date-msg").removeClass("hide");
      $(".product-form__item").find('[name="add"]').attr("aria-label", "Add to cart");
      $(".product-form__item").find("[data-add-to-cart-text]").text("Add to cart");
      var variantShippingInfo = JSON.parse($("#product-variant-quantity").html())
      var variantShippingMsg = variantShippingInfo[variant]["shipping-msg"];
      $(".delivery-date-msg .date-msg").text(variantShippingMsg);
      // two week function
      // weeks2update(true);
    }
    function variantNotAvailable() {
      $(".estimated_date,.shopify-payment-button__button,.stock__message,.delivery-date-msg").addClass("hide");
      $(".product-form__item").find('[name="add"]').attr("aria-label", "Sold out");
      $(".product-form__item").find("[data-add-to-cart-text]").text("Sold out");
      // two week function
      // weeks2update(false);
    }
    if (isVariantAvailable != undefined) {
      isVariantAvailable == false ? variantNotAvailable() : variantAvailable();
    }
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant;
    window.history.replaceState({ path: newurl }, "", newurl);
  });
});
